import "./EmployeeListForm.css";
import { Row, Col, DatePicker, Checkbox, Modal, Spin } from "antd";
import React from "react";
import AdnAutoComplete from "../common/adnAutoComplete/AdnAutoComplete";
import AdnMergeButton from "../common/adnMergeButton/AdnMergeButton";
import AdnCard from "../common/adnCard/AdnCard";
import AdnPageTitle from "../common/adnPageTitle/AdnPageTitle";
import AdnTable from "../common/adnTable/AdnTable";
import AdnDropdown from "../common/adnDropdown/AdnDropdown";
import {
  getConsultantTypeOptions,
  getHiredTypeOptions,
  dateFormat,
  RolesDescription,
} from "../common/GeneralConfigurations";
import { useState, useEffect } from "react";
import { AdnValidationAdentisEmail } from "../login/LoginValidations";
import AdnInput from "../common/adnInput/AdnInput";
import PhoneInput from "react-phone-number-input";
import { NumberValidation } from "./EmployeeValidations";
import { Button } from "antd";
import { Filter, X } from "react-feather";
import { ExportOutlined } from "@ant-design/icons";
import { getSetting } from "../../api/SettingApi";
import { getEmployeeByIds } from "../../api/EmployeeApi";
import { migrate } from "../../api/EmployeeMigrationApi";
import { userHasRolePermission } from "../../api/ApiUtils";
import moment from "moment";
import { useTranslation } from "react-i18next";

const { RangePicker } = DatePicker;

export const EmployeeListForm = ({
  title,
  currentPage,
  totalRecords,
  handleTableChanges,
  handleChangePage,
  handleSearch,
  handleSelect,
  handleAdd,
  employees,
  searchOptions,
  columns,
  getRowClassName,
  careerLevelList,
  contractTypeList,
  countryList,
  managersList,
  humanResourcesList,
  workPlaceList,
  primaveraDepartmentList,
  handleChangeContractType,
  handleChangeCareerLevel,
  handleChangeConsultantType,
  handleChangeHiredType,
  handleChangeEmail,
  handleChangeNUmber,
  handleChangePhone,
  handleChangeGender,
  handleChangeCountry,
  handleChangeManager,
  handleChangeUserHR,
  handleChangeWorkPlace,
  handleChangeWorkPlaceHR,
  handleChangeCurrentCompany,
  handleChangeBirthDate,
  handleChangeAdmissionDate,
  handleChangeAdmissionCTIDate,
  handleChangeResignationDate,
  handleChangePrimaveraDepartment,
  handleChangeDismissalComment,
  handleChangeMissingCorp,
  handleChangeMissingInquiry,
  handleChangeMissingProfile,
  handleChangeMissingIntegration,
  handleChangeMissingAssessment,
  loading,
  carrearLevel,
  contractType,
  consultantType,
  hiredType,
  searchName,
  email,
  phone,
  number,
  gender,
  nationalityId,
  workPlaceId,
  workPlaceIdHumanResource,
  managerId,
  userIdHumanResource,
  currentCompany,
  primaveraDepartmentId,
  dismissalComment,
  tableLoading,
  isManager,
  handleEmployeesExcel,
  checkedIds,
  setCheckedIds,
  saveLocalVariables,
  checkLocalVariables,
}) => {
  const { t } = useTranslation();
  const [showFilters, setShowFilters] = useState(false);
  const [settingADNProfileActive, setSettingADNProfileActive] = useState([]);
  const [settingProfileEmailActive, setSettingProfileEmailActive] = useState(
    [],
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [loadingModal, setLoadingModal] = useState(false);

  const showModal = async () => {
    setLoadingModal(true);
    getEmployeeByIds(checkedIds).then((res) => {
      if (res.data && res.data.employees) {
        res.data.employees.forEach((element) => {
          element.admissionDate = moment(element.admissionDate)?.format(
            dateFormat,
          );
        });
        setDataList(res.data.employees);
      } else setDataList([]);
      setLoadingModal(false);
    });
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    if (dataList && dataList.length === 2) {
      let migrateData = {};
      migrateData.employeeIdKeep = dataList[0].id;
      migrateData.corpUserIdKeep = dataList[0].corpUserId;
      migrateData.dismissalDate = dataList[0].resignationDate;
      migrateData.employeeIdMigrate = dataList[1].id;
      migrateData.corpUserIdMigrate = dataList[1].corpUserId;

      migrate(migrateData).then((res) => {
        saveLocalVariables();
        handleChangePage();
        checkLocalVariables();
        setCheckedIds([]);
        setIsModalOpen(false);
      });
    } else {
      setCheckedIds([]);
      setIsModalOpen(false);
    }
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const renderItems = () => {
    const elements = [];
    if (dataList && dataList.length === 2) {
      const firstItem = dataList[0];
      const secondItem = dataList[1];

      elements.push(
        <Row
          className="gutter-row"
          gutter={16}
          style={{
            marginLeft: 10,
            marginRight: 10,
            border: "1px solid #d9d9d9",
            padding: "16px",
            borderRadius: "8px",
            marginBottom: "16px",
          }}
        >
          <Col span={2}>{firstItem.number}</Col>
          <Col span={8}>{firstItem.name}</Col>
          <Col span={2}>
            {firstItem.contractName ? (
              firstItem.contractName.split(" ")[0]
            ) : (
              <></>
            )}
          </Col>
          <Col span={4}>
            <b>{firstItem.admissionDate}</b>
          </Col>
          <Col span={8}>{firstItem.email}</Col>
        </Row>,
      );

      elements.push(
        <Row
          className="gutter-row"
          gutter={16}
          style={{
            marginLeft: 10,
            marginRight: 10,
            border: "1px solid #d9d9d9",
            padding: "16px",
            borderRadius: "8px",
            marginBottom: "16px",
          }}
        >
          <Col span={2}>
            <b>{secondItem.number}</b>
          </Col>
          <Col span={8}>
            <b>{secondItem.name}</b>
          </Col>
          <Col span={2}>
            <b>
              {secondItem.contractName ? (
                secondItem.contractName.split(" ")[0]
              ) : (
                <></>
              )}
            </b>
          </Col>
          <Col span={4}>{secondItem.admissionDate}</Col>
          <Col span={8}>
            <b>{secondItem.email}</b>
          </Col>
        </Row>,
      );

      elements.push(
        <Row
          style={{
            marginLeft: 10,
            marginRight: 10,
          }}
        >
          <Col span={24}>{t("employeeListForm.modal.mergeResult")}</Col>
        </Row>,
      );

      elements.push(
        <Row
          className="gutter-row"
          gutter={16}
          style={{
            marginLeft: 10,
            marginRight: 10,
            border: "2px solid #005888",
            padding: "16px",
            borderRadius: "8px",
            marginBottom: "16px",
          }}
        >
          <Col span={2}>{secondItem.number}</Col>
          <Col span={8}>{secondItem.name}</Col>
          <Col span={2}>
            {secondItem.contractName ? (
              secondItem.contractName.split(" ")[0]
            ) : (
              <></>
            )}
          </Col>
          <Col span={4}>{firstItem.admissionDate}</Col>
          <Col span={8}>{secondItem.email}</Col>
        </Row>,
      );
    }

    return elements;
  };

  const onClickFilters = () => {
    setShowFilters(!showFilters);
  };

  const getSettingADNProfileActive = async () => {
    let settingId = "CF367BD3-9DC6-428B-A233-C44D76981741";
    getSetting(settingId).then((res) => {
      setSettingADNProfileActive(res.data);
    });
  };

  const getSettingProfileEmailActive = async () => {
    let settingId = "BCCD6F54-9EF7-4DED-8645-F2F02B67DC88";
    getSetting(settingId).then((res) => {
      setSettingProfileEmailActive(res.data);
    });
  };

  useEffect(() => {
    getSettingADNProfileActive();
    getSettingProfileEmailActive();
  }, []);

  return (
    <>
      <AdnPageTitle title={title} />
      <AdnCard loading={loading}>
        <div className="consultants-list-actions">
          {checkedIds.length === 2 &&
            (userHasRolePermission(RolesDescription.HumanResources) ||
              userHasRolePermission(RolesDescription.Admin)) && (
              <AdnMergeButton
                handleClick={showModal}
                name={t("employeeListForm.buttons.merge")}
                className="adn-primary-button"
                loading={loadingModal}
              />
            )}
          {/*{!isManager &&*/}
          {/*    <AdnAddButton handleClick={handleAdd} name={"Add Consultant"} />*/}
          {/*}*/}
          <div className="filter-group">
            <div className="filter-item" id="name">
              <AdnAutoComplete
                placeholder={t("employeeListForm.placeholders.searchName")}
                resultList={searchOptions}
                defaultValue={searchName}
                valueId={"name"}
                handleSearch={handleSearch}
                handleSelect={handleSelect}
              />
            </div>
            <div className="filter-item" id="contract-type">
              <AdnDropdown
                handleChange={handleChangeContractType}
                placeholder={t("employeeListForm.placeholders.contractType")}
                allowClear={true}
                defaultValue={contractType}
                options={contractTypeList}
              />
            </div>
            <div className="filter-item" id="career-level">
              <AdnDropdown
                handleChange={handleChangeCareerLevel}
                placeholder={t("employeeListForm.placeholders.careerLevel")}
                allowClear={true}
                defaultValue={carrearLevel}
                options={careerLevelList}
                dropdownMatchSelectWidth={false}
              />
            </div>
            <div className="filter-item" id="consultant-type">
              <AdnDropdown
                handleChange={handleChangeConsultantType}
                placeholder={t("employeeListForm.placeholders.consultantType")}
                allowClear={true}
                defaultValue={consultantType}
                options={getConsultantTypeOptions(t)}
              />
            </div>
            <div className="filter-item" id="job-state">
              <AdnDropdown
                handleChange={handleChangeHiredType}
                placeholder={t("employeeListForm.placeholders.jobState")}
                allowClear={true}
                defaultValue={hiredType}
                options={getHiredTypeOptions(t)}
              />
            </div>
            <div className="filter-btn">
              {showFilters ? (
                <Button
                  onClick={() => onClickFilters()}
                  className="filters adn-outlined-button selected"
                >
                  <X /> &nbsp; {t("employeeListForm.buttons.close")}
                </Button>
              ) : (
                <Button
                  onClick={() => onClickFilters()}
                  className="filters adn-outlined-button"
                >
                  <Filter /> &nbsp; {t("employeeListForm.buttons.filters")}
                </Button>
              )}
            </div>
            <div>
              <Button
                className="adn-primary-button"
                type="submit"
                onClick={handleEmployeesExcel}
              >
                <ExportOutlined /> {t("employeeListForm.buttons.export")}
              </Button>
            </div>
          </div>
        </div>

        {showFilters && (
          <Row className="gutter-row hide-filters fade-in-filters">
            <Row
              className="gutter-row"
              gutter={16}
              style={{ marginLeft: 10, marginRight: 10 }}
            >
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 8 }}
                xl={{ span: 6 }}
              >
                <AdnInput
                  name="email"
                  type="email"
                  placeholder={t("employeeListForm.placeholders.email")}
                  maxLength={"50"}
                  handleChange={handleChangeEmail}
                  rules={AdnValidationAdentisEmail}
                  defaultValue={email}
                  value={email}
                />
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 8 }}
                xl={{ span: 4 }}
                style={{ marginBottom: 24 }}
              >
                <PhoneInput
                  international
                  defaultCountry="PT"
                  placeholder={t("employeeListForm.placeholders.phoneNumber")}
                  onChange={handleChangePhone}
                  value={phone}
                />
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 8 }}
                xl={{ span: 4 }}
              >
                <AdnDropdown
                  name="gender"
                  type="text"
                  rules={[
                    {
                      required: true,
                      message: t("employeeListForm.validation.genderRequired"),
                    },
                  ]}
                  placeholder={t("employeeListForm.placeholders.gender")}
                  handleChange={handleChangeGender}
                  allowClear={true}
                  defaultValue={gender === "" ? null : gender}
                  options={[
                    { id: "M", name: "Male" },
                    { id: "F", name: "Female" },
                  ]}
                />
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 8 }}
                xl={{ span: 4 }}
              >
                <AdnDropdown
                  name="nationalityId"
                  type="text"
                  placeholder={t(
                    "employeeListForm.placeholders.selectNationality",
                  )}
                  options={countryList}
                  allowClear={true}
                  rules={[
                    {
                      required: true,
                      message: t(
                        "employeeListForm.validation.nationalityRequired",
                      ),
                    },
                  ]}
                  handleChange={handleChangeCountry}
                  defaultValue={nationalityId === "" ? null : nationalityId}
                />
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 8 }}
                xl={{ span: 4 }}
              >
                <AdnInput
                  name="number"
                  rules={NumberValidation()}
                  placeholder={t(
                    "employeeListForm.placeholders.consultantNumber",
                  )}
                  maxLength={30}
                  handleChange={handleChangeNUmber}
                  defaultValue={number}
                  value={number}
                />
              </Col>

              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 8 }}
                xl={{ span: 6 }}
              >
                <AdnDropdown
                  name="managerId"
                  type="text"
                  rules={[
                    {
                      required: true,
                      message: t("employeeListForm.validation.managerRequired"),
                    },
                  ]}
                  placeholder={t("employeeListForm.placeholders.selectManager")}
                  allowClear={true}
                  options={managersList}
                  handleChange={handleChangeManager}
                  defaultValue={
                    managerId === "" || managerId === 2 ? null : managerId
                  }
                  mode={"multiple"}
                />
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 8 }}
                xl={{ span: 4 }}
              >
                <AdnDropdown
                  name="workPlaceId"
                  type="text"
                  placeholder={t(
                    "employeeListForm.placeholders.selectLocation",
                  )}
                  allowClear={true}
                  options={workPlaceList}
                  rules={[
                    {
                      required: true,
                      message: t(
                        "employeeListForm.validation.locationRequired",
                      ),
                    },
                  ]}
                  handleChange={handleChangeWorkPlace}
                  defaultValue={workPlaceId === "" ? null : workPlaceId}
                />
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 8 }}
                xl={{ span: 6 }}
              >
                <AdnInput
                  name="currentCompany"
                  placeholder={t(
                    "employeeListForm.placeholders.insertCurrentClient",
                  )}
                  maxLength={50}
                  handleChange={handleChangeCurrentCompany}
                  defaultValue={currentCompany}
                  value={currentCompany}
                />
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 8 }}
                xl={{ span: 6 }}
              >
                <AdnDropdown
                  name="primaveraDepartmentId"
                  type="text"
                  placeholder="Primavera Department"
                  allowClear={true}
                  options={primaveraDepartmentList}
                  handleChange={handleChangePrimaveraDepartment}
                  defaultValue={
                    primaveraDepartmentId === "" ? null : primaveraDepartmentId
                  }
                />
              </Col>
            </Row>
            <Row
              className="gutter-row"
              gutter={16}
              style={{
                marginLeft: 10,
                marginRight: 10,
                width: "100%",
                paddingRight: "8%",
              }}
            >
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 8 }}
                xl={{ span: 8 }}
              >
                <AdnInput
                  name="dismissalComment"
                  placeholder="Dismissal Comment"
                  maxLength={100}
                  handleChange={handleChangeDismissalComment}
                  defaultValue={dismissalComment}
                  value={dismissalComment}
                />
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 8 }}
                xl={{ span: 8 }}
              >
                <AdnDropdown
                  name="workPlaceIdHumanResource"
                  type="text"
                  placeholder={t(
                    "employeeListForm.placeholders.selectLocationHR",
                  )}
                  allowClear={true}
                  options={workPlaceList}
                  handleChange={handleChangeWorkPlaceHR}
                  defaultValue={
                    workPlaceIdHumanResource === ""
                      ? null
                      : workPlaceIdHumanResource
                  }
                />
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 8 }}
                xl={{ span: 8 }}
              >
                <AdnDropdown
                  name="userIdHumanResource"
                  type="text"
                  placeholder={t("employeeListForm.placeholders.selectUserHR")}
                  allowClear={true}
                  options={humanResourcesList}
                  handleChange={handleChangeUserHR}
                  defaultValue={
                    userIdHumanResource === "" ? null : userIdHumanResource
                  }
                />
              </Col>
            </Row>

            <Row
              className="gutter-row"
              gutter={16}
              style={{ marginLeft: 10, marginRight: 10 }}
            >
              {/*FIXME -  the dates are selected and when the filters are closed and reopen they appear empty*/}
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 8 }}
                xl={{ span: 6 }}
              >
                <p>{t("employeeListForm.labels.birthDate")}</p>
                <RangePicker onChange={handleChangeBirthDate}></RangePicker>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 8 }}
                xl={{ span: 6 }}
              >
                <p>{t("employeeListForm.labels.admissionDate")}</p>
                <RangePicker onChange={handleChangeAdmissionDate}></RangePicker>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 8 }}
                xl={{ span: 6 }}
              >
                <p>{t("employeeListForm.labels.admissionCTIDate")}</p>
                <RangePicker
                  onChange={handleChangeAdmissionCTIDate}
                ></RangePicker>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 8 }}
                xl={{ span: 6 }}
              >
                <p>{t("employeeListForm.labels.resignationDate")}</p>
                <RangePicker
                  onChange={handleChangeResignationDate}
                ></RangePicker>
              </Col>
            </Row>

            <Row
              className="gutter-row"
              style={{ marginTop: 10, marginLeft: 18, marginRight: 18 }}
            >
              <Col>
                <p>{t("employeeListForm.labels.missingEmails")}</p>{" "}
                {/*REVIEW - this is not a explicit name*/}
                {/*FIXME - the checkbox are selected and when the filters are closed and reopen they appear unchecked */}
                <Checkbox.Group
                  style={{
                    width: "100%",
                  }}
                >
                  <Row style={{ gap: 12 }}>
                    <Col>
                      <Checkbox value="Corp" onChange={handleChangeMissingCorp}>
                        <div className="checkbox-label">
                          {t("employeeListForm.checkboxes.corp")}
                          <div className="AvatarColorYellow dot"></div>
                        </div>
                      </Checkbox>
                    </Col>
                    <Col>
                      <Checkbox
                        value="Integration"
                        onChange={handleChangeMissingIntegration}
                      >
                        <div className="checkbox-label">
                          {t("employeeListForm.checkboxes.integration")}
                          <div className="AvatarColorRed dot"></div>
                        </div>
                      </Checkbox>
                    </Col>
                    {settingADNProfileActive.value === "TRUE" && (
                      <Col>
                        <Checkbox
                          value="ADN Profile"
                          onChange={handleChangeMissingInquiry}
                        >
                          <div className="checkbox-label">
                            {t("employeeListForm.checkboxes.adnProfile")}
                            <div className="AvatarColorGreen dot"></div>
                          </div>
                        </Checkbox>
                      </Col>
                    )}
                    {settingProfileEmailActive.value === "TRUE" && (
                      <Col>
                        <Checkbox
                          value="Profile"
                          onChange={handleChangeMissingProfile}
                        >
                          <div className="checkbox-label">
                            {t("employeeListForm.checkboxes.profile")}
                            <div className="AvatarColorBlue dot"></div>
                          </div>
                        </Checkbox>
                      </Col>
                    )}
                    <Col>
                      <Checkbox
                        value="Assessment"
                        onChange={handleChangeMissingAssessment}
                      >
                        <div className="checkbox-label">
                          {t("employeeListForm.checkboxes.assessment")}
                          <div className="AvatarColorGray dot"></div>
                        </div>
                      </Checkbox>
                    </Col>
                  </Row>
                </Checkbox.Group>
              </Col>
            </Row>
          </Row>
        )}

        <Row>
          <Col span={24}>
            <AdnTable
              className={"employeeList"}
              columns={columns}
              loading={tableLoading}
              data={employees}
              currentPage={currentPage}
              totalRecords={totalRecords}
              handleChange={handleTableChanges}
              handleChangePage={handleChangePage}
              getRowClassName={getRowClassName}
            />
          </Col>
        </Row>
      </AdnCard>
      <Modal
        title={t("employeeListForm.modal.mergeEntries")}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width="920px"
      >
        {loadingModal ? (
          <Row>
            <Col span={24} align="middle">
              <Spin />
            </Col>
          </Row>
        ) : (
          renderItems()
        )}
      </Modal>
    </>
  );
};
